import { createContext, useContext, type ReactNode } from 'react';

const PrintModeContext = createContext(false);

export function PrintModeProvider({ children }: { children: ReactNode }) {
  return <PrintModeContext.Provider value={true}>{children}</PrintModeContext.Provider>;
}

export const usePrintMode = () => useContext(PrintModeContext);

/** Conteúdo formado apenas por código existe só na tela — nunca no PDF. */
export function ScreenOnlyCode({ children }: { children: ReactNode }) {
  return usePrintMode() ? null : <>{children}</>;
}

/** Conteúdo exclusivo do documento impresso. */
export function PrintOnly({ children }: { children: ReactNode }) {
  return usePrintMode() ? <>{children}</> : null;
}
